import styles from "./Testimonial.module.scss";

import Typography from "../Typography";
import { TypographyVariants } from "../../Contracts";

export const Testimonial = (props) => {

  if (!props.thumbnail || (!props.name && !props.company)) {
    return null;
  }

  return (
    <div className={`${styles.TestimonialContainer} ${props.className ? props.className : ''}`} id={props.id} style={props.style ? props.style : {}}>
      {props.thumbnail && <div className={`${styles.TestimonialThumbnail} ${props.thumbnailClassName ? props.thumbnailClassName : ''}`}>{props.thumbnail}</div>}
      {(props.name || props.company) && (
        <div className={`${styles.TestimonialContent} ${props.testimonialContentClassName ? props.testimonialContentClassName : ''}`}>
          {props.name && (
            <Typography
              variant={TypographyVariants.DIV}
              style={{ fontSize: '20px', fontWeight: '700', color: 'var(--black)' }}
              tabletStyle={{ fontSize: '19px' }}
              mobileStyle={{ fontSize: '18px' }}
              className={`${styles.TestimonialName} ${props.testimonialNameClassName ? props.testimonialNameClassName : ''}`}
            >
              {props.name}
            </Typography>
          )}
          {props.company && (
            <Typography
              variant={TypographyVariants.DIV}
              style={{ fontSize: '18px', fontWeight: '400', color: 'var(--black)' }}
              tabletStyle={{ fontSize: '17px' }}
              mobileStyle={{ fontSize: '16px' }}
              className={`${styles.TestimonialCompany} ${props.testimonialCompanyClassName ? props.testimonialCompanyClassName : ''}`}
            >
              {props.company}
            </Typography>
          )}
        </div>
      )}
    </div>
  );

};

export default Testimonial;
